/**
 * Regex for validating email addresses.
 * TODO: Possible unsafe regexp, see sonarjs error below for more info.
 */
// eslint-disable-next-line sonarjs/slow-regex
export const EMAIL_VALIDATION_REGEX = /^\S+@\S+\.[^\s\d]{2,}$/u;

/** The maximum length of the username. */
export const USERNAME_MAX_LENGTH = 99;

/** Regex for validating usernames. */
export const USERNAME_VALIDATION_REGEX = new RegExp(String.raw`^[\d_a-z-]{1,${USERNAME_MAX_LENGTH}}$`, "u");

/** The count of the username ID digits. */
export const USERNAME_ID_LENGTH = 3;

/** Regexp for validating username IDs. */
export const USERNAME_ID_VALIDATION_REGEX = new RegExp(`^[0-9]{${USERNAME_ID_LENGTH}}$`, "u");

/** Minimum password length for user accounts. */
export const PASSWORD_MIN_LENGTH = 6;

/** Exact length for the device linking codes. */
export const DEVICE_LINKING_CODE_LENGTH = 16;

/** Minimum length for the search input fields. */
export const SEARCH_STRING_MIN_LENGTH = 2;

/** Maximum length for the search input fields. */
export const SEARCH_STRING_MAX_LENGTH = 25;

/** Minimum length for the use group name. */
export const USER_GROUP_NAME_MIN_LENGTH = 3;

/** Maximum length for the device name. */
export const DEVICE_NAME_MAX_LENGTH = 99;

/** Minimum length for the device name. */
export const DEVICE_NAME_MIN_LENGTH = 1;

/** Maximum length for the device location. */
export const DEVICE_LOCATION_MAX_LENGTH = 255;

/** Minimum length for the device location. */
export const DEVICE_LOCATION_MIN_LENGTH = 0;

/** The maximum size for the latitude number. */
export const DEVICE_LATITUDE_MIN = -90;

/** The minimum size for the latitude number. */
export const DEVICE_LATITUDE_MAX = 90;

/** The maximum size for the longitude number. */
export const DEVICE_LONGITUDE_MIN = -180;

/** The minimum size for the longitude number. */
export const DEVICE_LONGITUDE_MAX = 180;

/** Regex for validating UrlId parameter. */
export const URL_ID_VALIDATION_REGEX = /^[a-zA-Z0-9_-]{16}$/u;

/** Regex for phone MSISDN phone number format. */
export const MSISDN_VALIDATION_REGEX = /^\d{8,15}$/u;